export interface IToWhomCall {
  number: string
  name?: string
  secondary?: string
  avatarUrl?: string
  from?: string
  uniqId?: string
  scheme?: string
}

export interface IOutgoingCall {
  userId?: string
  toWhom: IToWhomCall
}

export enum ToolConfiguration {
  CALL_MANAGER = 'CALL_MANAGER',
  ADD = 'ADD',
  DIALPLADE = 'DIALPLADE',
  HISTORY = 'HISTORY',
  TRANSFER = 'TRANSFER',
  CONTACTS = 'CONTACTS',
  NONE = 'NONE',
}

export enum CallState {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  ANSWERED = 'ANSWERED',
}

export enum CallType {
  OUTGOING = 'outgoing',
  INCOMING = 'incoming',
  MISSED = 'missed',
}

export enum ECallStatus {
  BUSY = 'busy',
  COMPLETED = 'completed',
  FAILED = 'failed',
  IN_PROGRESS = 'in-progress',
  INITIATED = 'initiated',
  NO_ANSWER = 'no-answer',
  RINGING = 'ringing',
}
export interface ICall {
  id: number
  accountId: number
  externalId: null
  subscriberId: number
  type: `${CallType}`
  status: `${ECallStatus}`
  syncAt: string
  duration: string | null
  createdAt: string
  updatedAt: string
  recordingUrl?: string
  subscriber: {
    identifier: string
    storageObjects?:
      | {
          uniqId: string
          objectSchemeIdentifier: string
          primary: string
          secondary: string
          icon: string
          parentObjectUniqId?: string
          parentObjectSchemeIdentifier?: string
        }[]
      | null
  }
  userData?: {
    createdAt: string
    id: number
    identifier: string
    info?: {
      avatar?: string
      firstName?: string
      lastName?: string
    }
  }
  userId?: number
  account: {
    id: number
    identifier: string
    internalId: number
    driver: string
    status: string
    createdAt: string
    updatedAt: string
    assignedUserIds?: number[]
    number: {
      id: number
      partnerGlobalId: null
      driver: string
      regionCode: string
      phoneNumber: string
      displayName: string
      active: true
      syncAt: string
      createdAt: string
      updatedAt: string
    }
  }
}
